import { useEffect, useState } from "react";

import authorImage from "../../assets/Asman_PIc-Copy.jpeg";

import sqlmapMainImage from "../../assets/blog_images/sqliWithSqlMap/exploiting-sqli-with-sqlmap.png";
import sqlmapPic1 from "../../assets/blog_images/sqliWithSqlMap/pic1.png";
import sqlmapPic2 from "../../assets/blog_images/sqliWithSqlMap/pic2.png";
import sqlmapPic3 from "../../assets/blog_images/sqliWithSqlMap/pic3.png";
import sqlmapPic4 from "../../assets/blog_images/sqliWithSqlMap/pic4.png";
import sqlmapPic5 from "../../assets/blog_images/sqliWithSqlMap/pic5.png";
import sqlmapPic6 from "../../assets/blog_images/sqliWithSqlMap/pic6.png";
import sqlmapPic7 from "../../assets/blog_images/sqliWithSqlMap/pic7.png";

import sqlInjectionImage from "../../assets/blog_images/sqlInjection/sql_injection1.jpg";
import brokenAccessImage from "../../assets/blog_images/BrokenAccessControllAuthentication/brokenThumbnail.png";
import sessionImage from "../../assets/blog_images/sessionManagement/session1.png";

const SUPPORT_WHATSAPP_NUMBER = "919080432374";
const SUPPORT_MESSAGE = "Hi, I am Looking for Cyber Security Training";

function SqliWithSqlMap() {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    document.title = "SQLI with SQLMap";

    function handleScroll() {
      setShowBackToTop(window.scrollY > 300);
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function openWhatsAppChat() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const waMe = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.open(waMe, "_blank", "noopener,noreferrer");
  }

  function openWhatsAppAppFallback() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const deepLink = `whatsapp://send?phone=${SUPPORT_WHATSAPP_NUMBER}&text=${encoded}`;
    const webLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.location.href = deepLink;

    setTimeout(() => {
      window.open(webLink, "_blank", "noopener,noreferrer");
    }, 700);
  }

  return (
    <main className="overflow-x-hidden bg-white">
      <section className="w-full max-w-5xl px-4 py-10 mx-auto overflow-x-hidden bg-white">
        <article className="article post tag-hackthebox image-small">
          <header className="article-header gh-canvas">
            <div className="mb-2 article-tag post-card-tags">
              <span className="post-card-primary-tag">
                <a href="" className="text-blue-600">
                  WebApplicationSecurity
                </a>
              </span>
            </div>

            <h1 className="mb-4 text-4xl font-semibold article-title">
              Exploiting SQL Injections Automatically Using SQLmap
            </h1>

            <p className="mb-6 text-gray-800 article-excerpt">
              SQLmap is an open-source penetration testing tool that automates
              the process of detecting and exploiting SQL injection
              vulnerabilities. It helps security testers efficiently extract
              data, access databases, and even gain system control.
            </p>

            {/* Article Author Info */}
            <div className="flex flex-col items-start justify-between mb-6 sm:flex-row sm:items-center">
              {/* Left Section */}
              <div className="flex items-start gap-4">
                <img
                  className="w-12 h-12 rounded-full"
                  src={authorImage}
                  alt="Asman"
                />

                <div>
                  <h4 className="text-lg font-semibold">
                    <a href="">Asman</a>
                  </h4>

                  <div className="text-sm font-medium text-gray-500">
                    <time dateTime="2025-05-03">May 06, 2025</time>
                    <span className="ml-1">• 5 min read</span>
                  </div>
                </div>
              </div>

              {/* Right Section: Share Icon */}
              <button
                type="button"
                onClick={() => setShareModalOpen(true)}
                className="mt-5 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
              >
                {/* Share Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>

            {/* Share Modal */}
            {shareModalOpen && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50"
                onClick={(event) => {
                  if (event.target === event.currentTarget) {
                    setShareModalOpen(false);
                  }
                }}
              >
                <div className="p-6 text-black bg-gray-200 rounded-md w-80">
                  <h2 className="mb-4 text-lg font-semibold">
                    Share this article
                  </h2>

                  <div className="flex items-center justify-around">
                    {/* X / Twitter */}
                    <a
                      href="https://twitter.com/intent/tweet?text=https://www.practicalinfosec.com/broken_Access_Control_Athentication"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-500"
                    >
                      <svg className="w-10 h-10 fill-current" viewBox="0 0 24 24">
                        <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.83 1.08A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.64 2.24-4.04 4.79A12.94 12.94 0 0 1 1.64 1.14a4.52 4.52 0 0 0-.61 2.27 4.5 4.5 0 0 0 2 3.75 4.41 4.41 0 0 1-2.06-.56v.06a4.53 4.53 0 0 0 3.63 4.43 4.52 4.52 0 0 1-2.04.08 4.53 4.53 0 0 0 4.22 3.14A9.05 9.05 0 0 1 0 19.54a12.93 12.93 0 0 0 7 2.05c8.4 0 13-7.5 12.68-14.23A9.18 9.18 0 0 0 23 3z" />
                      </svg>
                    </a>

                    {/* Facebook */}
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https://www.practicalinfosec.com/broken_Access_Control_Athentication"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-700"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M22.675 0h-21.35C.592 0 0 .593 0 1.326v21.348C0 23.408.592 24 1.325 24H12.82V14.708h-3.293V11.17h3.293V8.413c0-3.26 1.986-5.038 4.89-5.038 1.39 0 2.585.104 2.933.15v3.4l-2.013.001c-1.577 0-1.883.75-1.883 1.85v2.43h3.766l-.491 3.538h-3.275V24h6.42C23.408 24 24 23.408 24 22.675V1.325C24 .593 23.408 0 22.675 0z" />
                      </svg>
                    </a>

                    {/* LinkedIn */}
                    <a
                      href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.practicalinfosec.com/broken_Access_Control_Athentication"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-600"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M20.447 20.452H17.24V14.8c0-1.345-.025-3.078-1.879-3.078-1.88 0-2.168 1.464-2.168 2.976v5.753h-3.207V9h3.076v1.561h.043c.429-.811 1.476-1.666 3.036-1.666 3.246 0 3.844 2.137 3.844 4.917v6.64zM5.337 7.433c-1.034 0-1.873-.839-1.873-1.874 0-1.034.839-1.873 1.873-1.873 1.036 0 1.875.839 1.875 1.873s-.839 1.874-1.875 1.874zM6.789 20.452H3.885V9h2.904v11.452zM22.225 0H1.771C.791 0 0 .77 0 1.723v20.555C0 23.23.79 24 1.771 24h20.451C23.21 24 24 23.23 24 22.278V1.723C24 .77 23.21 0 22.225 0z" />
                      </svg>
                    </a>
                  </div>

                  <button
                    type="button"
                    onClick={() => setShareModalOpen(false)}
                    className="block mx-auto mt-4 text-sm text-gray-600 underline hover:text-black"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            <figure className="mb-6 article-image">
              <img
                src={sqlmapMainImage}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>
          </header>

          <section className="gh-content gh-canvas">
            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Understanding SQL Injection :
            </h2>

            <p className="mb-4">
              SQL injection is a type of security vulnerability that allows
              attackers to interfere with the queries an application makes to
              its database. It occurs when malicious SQL code is inserted into
              input fields or URL parameters, which the database server then
              executes as part of a legitimate query. This can enable attackers
              to view, modify, or delete sensitive data, bypass authentication,
              and in some cases, gain full control over the system. SQL
              injection remains one of the most critical and commonly exploited
              web application vulnerabilities.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Introduction to SQLmap :
            </h2>

            <p className="mb-4">
              SQLmap is a widely used open-source penetration testing tool that
              automates the detection and exploitation of SQL injection
              vulnerabilities in web applications. It supports a wide range of
              database management systems, including MySQL, PostgreSQL, Microsoft
              SQL Server, and Oracle. With its extensive features, SQLmap can
              identify injection points, enumerate databases and tables, extract
              data, run arbitrary SQL queries, and even brute-force database
              credentials. It’s an essential tool for ethical hackers and
              security professionals looking to assess and strengthen the
              security of web applications.
            </p>

            <ul className="mb-4 ml-6 space-y-2 text-gray-800 list-disc list-inside">
              <li className="transition-colors duration-200 hover:text-blue-600">
                Detecting SQL injection flaws in web applications
              </li>
              <li className="transition-colors duration-200 hover:text-blue-600">
                Enumerating databases, tables, and columns
              </li>
              <li className="transition-colors duration-200 hover:text-blue-600">
                Extracting (dumping) data from databases
              </li>
              <li className="transition-colors duration-200 hover:text-blue-600">
                Executing custom SQL queries
              </li>
              <li className="transition-colors duration-200 hover:text-blue-600">
                Brute-forcing database credentials
              </li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Hands-On with SQLmap
            </h2>

            <p className="mt-4 mb-4">
              Let’s explore a basic scenario where SQLmap is used to identify
              and exploit a SQL injection flaw.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Identifying Vulnerable Parameters :
            </h2>

            <p className="mb-4">
              First, we need to identify a vulnerable parameter in the target web
              application. This could be a URL parameter, form field, or cookie
              value that is susceptible to SQL injection.
            </p>

            <p className="mb-4">Here Search field is the susceptible parameter</p>

            <figure className="mb-6 article-image">
              <img
                src={sqlmapPic1}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>

            <figure className="mb-6 article-image">
              <img
                src={sqlmapPic2}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-2 text-3xl font-semibold">
              1. Scanning for Vulnerabilities :
            </h2>

            <p className="mb-4">
              Begin by scanning the target URL to detect potential SQL injection
              flaws. Use the following command:
            </p>

            <figure className="mb-6 article-image">
              <img
                src={sqlmapPic3}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4">
              This command tells SQLmap to test the URL for injection points and
              enumerate the available databases.
            </p>

            <h2 id="network-scan" className="mb-2 text-3xl font-semibold">
              2. Enumerating Tables from a Specific Database
            </h2>

            <p className="mb-4">
              Once the vulnerable URL is confirmed and databases are listed,
              choose a database to enumerate its tables :
            </p>

            <figure className="mb-6 article-image">
              <img
                src={sqlmapPic4}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-2 text-3xl font-semibold">
              3. Fetching Columns from a Specific Table
            </h2>

            <p className="mb-4">
              After identifying the table of interest, extract the column names :
            </p>

            <figure className="mb-6 article-image">
              <img
                src={sqlmapPic5}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-2 text-3xl font-semibold">
              4. Extracting Data (e.g., Usernames and Passwords)
            </h2>

            <p className="mb-4">
              Finally, retrieve the actual data from specific columns, such as
              usernames and passwords :
            </p>

            <figure className="mb-6 article-image">
              <img
                src={sqlmapPic6}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-2 text-3xl font-semibold">
              5. Exploiting the Vulnerability
            </h2>

            <p className="mb-4">
              By successfully extracting sensitive data such as usernames and
              passwords, you’ve confirmed the presence of a SQL injection
              vulnerability. This demonstrates how SQLmap can be used to
              automate the exploitation process and access protected database
              content.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={sqlmapPic7}
                alt="BrokenAccessControllAuthentication"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-2 text-3xl font-semibold">
              Best Practices and Ethical Considerations for Using SQLmap
            </h2>

            <h2 id="network-scan" className="mb-2 text-2xl font-semibold">
              Obtain Proper Authorization :
            </h2>

            <p className="mb-4">
              Never scan or exploit a system without explicit permission.
              Unauthorized testing is illegal and unethical.
            </p>

            <h2 id="network-scan" className="mb-2 text-2xl font-semibold">
              Use Responsibly :
            </h2>

            <p className="mb-4">
              SQLmap should only be used for educational purposes, penetration
              testing, or vulnerability assessments on systems you own or are
              authorized to test.
            </p>

            <h2 id="network-scan" className="mb-2 text-2xl font-semibold">
              Keep SQLmap Updated :
            </h2>

            <p className="mb-4">
              Regularly update SQLmap to benefit from the latest features, bug
              fixes, and security improvements, ensuring more accurate and
              effective testing.
            </p>
          </section>
        </article>
      </section>

      {/* Right Section: Share Icon */}
      <section className="w-full max-w-5xl px-4 mx-auto">
        <button
          type="button"
          onClick={() => setShareModalOpen(true)}
          className="mt-5 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
        >
          {/* Share Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </section>

      {/* Author Section */}
      <section className="max-w-5xl px-4 py-6 mx-auto mt-10 overflow-x-hidden rounded-lg">
        <div className="flex flex-col items-start gap-6 sm:flex-row">
          {/* Author Image */}
          <img
            src={authorImage}
            alt="Asman"
            className="object-cover w-24 h-24 rounded-lg"
          />

          {/* Author Info */}
          <div>
            <h3 className="mb-2 text-2xl font-semibold">Written by Asman</h3>

            <p className="mb-3 text-gray-700">Offensive Security Researcher.</p>

            <p className="text-gray-500 text-md">
              Published on <time dateTime="2023-02-11">May 06, 2025</time> • 7
              min read
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 text-black bg-white">
        <div className="max-w-screen-xl px-4 mx-auto sm:px-4 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a href="sql-injection" target="_blank" rel="noopener noreferrer">
                  <img
                    className="object-cover w-full h-48"
                    src={sqlInjectionImage}
                    alt="SQL Injection"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Understanding SQL Injection: A Web Security Threat
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    SQL Injection is a critical security flaw that allows
                    attackers to manipulate SQL queries, risking data breaches or
                    full database control.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 03, 2025</span>
                    <span>7 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 2 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="OWASPTop10"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="broken-access-control-authentication"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={brokenAccessImage}
                    alt="Broken Access Control Authentication"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">OWASPTop10</div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Broken Access Control & Auth: A Security Breakdown
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Broken Access Control and Authentication vulnerabilities are
                    critical security flaws that allow unauthorized users to gain
                    access to restricted areas.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 02, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="session-management"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={sessionImage}
                    alt="Session Management"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Secure Session Management: Best Practices & Techniques
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Session management is secure for user authentication in web
                    applications. Techniques to prevent session-related threats
                    like hijacking and fixation.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>Apr 28, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Repeat your blog cards here (already responsive) */}
          </div>
        </div>
      </section>

      {/* WhatsApp Sticky Button */}
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setWhatsappOpen((prev) => !prev);
        }}
        className="fixed z-50 p-3 px-4 text-white transition -translate-y-1/2 rounded-full shadow-lg cursor-pointer top-1/2 right-6 animate-blink hover:opacity-90 bg-gradient-to-r from-green-400 via-green-500 to-green-600"
        aria-label="Join WhatsApp"
      >
        <i className="text-4xl fa-brands fa-whatsapp"></i>
      </button>

      {/* WhatsApp Modal */}
      {whatsappOpen && (
        <div
          className="fixed z-50 p-4 transition-opacity duration-300 -translate-y-1/2 bg-white shadow-xl top-1/2 right-20 rounded-xl w-72 max-sm:right-4 max-sm:left-4 max-sm:w-auto"
          role="dialog"
          aria-modal="true"
          aria-labelledby="whatsappTitle"
        >
          {/* Close Button */}
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              setWhatsappOpen(false);
            }}
            className="absolute text-3xl text-gray-600 cursor-pointer top-2 left-4 hover:text-red-500"
            aria-label="Close"
          >
            &times;
          </button>

          <h2
            id="whatsappTitle"
            className="mt-6 mb-2 text-lg font-bold text-center text-gray-800"
          >
            Unsure about which course to choose?
          </h2>

          <p className="mb-3 text-sm text-center text-gray-700">
            Tap below to start a WhatsApp chat — we're here to help!
          </p>

          {/* Action buttons */}
          <div className="flex flex-col items-center gap-3">
            {/* Chat Now */}
            <button
              type="button"
              onClick={openWhatsAppChat}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-white transition bg-green-600 rounded-full hover:bg-green-700"
              aria-label="Chat Now on WhatsApp"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Chat Now
            </button>

            {/* Open in App */}
            <button
              type="button"
              onClick={openWhatsAppAppFallback}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-gray-800 transition border border-gray-200 rounded-full hover:bg-gray-50"
              aria-label="Open in WhatsApp App"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-green-600"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M20.52 3.48A11.93 11.93 0 0012 .5C5.73.5.99 5.24.99 11.5c0 2.01.53 3.95 1.53 5.68L0 24l6.97-1.79c1.61.45 3.28.68 4.9.68 6.27 0 11.01-4.74 11.01-11 0-3.02-1.18-5.85-3.36-7.41zM12 21.5c-1.44 0-2.86-.34-4.14-.99l-.3-.15-4.14 1.06 1.15-3.98-.18-.31A8.12 8.12 0 013 11.5c0-4.97 4.06-9 9-9 2.41 0 4.66.94 6.36 2.64a8.95 8.95 0 012.64 6.36c0 4.97-4.06 9-9 9z" />
              </svg>
              Open in App
            </button>
          </div>
        </div>
      )}

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed z-50 p-4 text-white transition bg-blue-700 rounded-lg shadow-lg cursor-pointer bottom-12 right-7 hover:bg-blue-700"
          aria-label="Back to top"
        >
          <i className="text-xl fa-solid fa-arrow-up"></i>
        </button>
      )}

      {/* Floating Call Button */}
      <a
        href="tel:+91-9080432374"
        className="fixed z-50 p-3 text-white transition rounded-md shadow-lg cursor-pointer bg-violet-600 bottom-60 right-7 hover:bg-green-700"
        aria-label="Call Us"
      >
        <i className="text-2xl fa-solid fa-phone"></i>
      </a>
    </main>
  );
}

export default SqliWithSqlMap;